<div mat-dialog-title class="!text-base">{{title}}</div>
<div mat-dialog-content class="py-0">
    <form #socialNetworkForm="ngForm">
        <div class="grid gap-y-2">
            <mat-form-field class="w-full">
                <mat-label>Red social</mat-label>
                <mat-select [(ngModel)]="socialNetwork.idTipoRed" name="idTipoRed" required>
                    <mat-option *ngFor="let sn of socialNetworks" [value]="sn.id">{{sn.name}}</mat-option>
                </mat-select>
                <mat-error>
                    Completa este campo.
                </mat-error>
            </mat-form-field>
            <mat-form-field class="w-full">
                <mat-label>{{ isWhatsApp ? 'Usuario de WhatsApp' : 'Url' }}</mat-label>
                <span *ngIf="isWhatsApp" matTextPrefix>&#64;</span>
                <input matInput type="text" autocomplete="off" [(ngModel)]="socialNetwork.red" name="red" required
                    [placeholder]="isWhatsApp ? 'usuario' : ''">
                <mat-hint *ngIf="isWhatsApp">Solo el usuario, sin el &#64; ni enlaces. Ej.: fujiki_nsou</mat-hint>
                <mat-error>
                    Completa este campo.
                </mat-error>
            </mat-form-field>
        </div>
    </form>
</div>

<div mat-dialog-actions align="end" class="!px-6">
    <button mat-stroked-button color="primary" class="me-4" (click)="cancel()" type="button">Cancelar</button>
    <adp-button-icon (clicked)="onSubmit()" color="primary" [disabled]="socialNetworkForm.invalid"
        label="Guardar"></adp-button-icon>
</div>